import { useNavigate, useParams } from "react-router-dom";
import ExtendService from "./ExtendService";
import { Box } from "@mui/material";

export const ShowService = () => {
  const { id } = useParams();

  const navigate = useNavigate();

  return (
    <Box className="pt-0 md:pt-12 w-full h-full flex flex-col">
      <ExtendService
        onDelete={() => navigate("/services")}
        row={{ id, onUpdate: () => {}, onDelete: () => {} }}
      />
      ;
    </Box>
  );
};
